require('C:\\OpenServer\\domains\\saugoma\\Project\\assets\\js\\shared.js')